export default __webpack_public_path__ + "3c095f24715a5efcb490b0330bcbbd6a.svg";